export default "__VITE_ASSET__DVvg2TZ5__"